import type * as lazyIndex from "./lazyIndex";
import { type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";
import { showMsalAuthInfoBar } from "./showMsalAuthInfoBar";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "MsalAuthInfoBar" */ "./lazyIndex"), { name: "MsalAuthInfoBar" });

export const MsalAuthInfoBar: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.MsalAuthInfoBar, undefined, undefined, { onlyImportIf: showMsalAuthInfoBar });

export const MsalAuthDialog: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.MsalAuthDialog);
